import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { DateTime } from "luxon";
import ScreenShow from "../../Components/ScreenShow";
import UpdateScheduleCampaign from "../../Components/UpdateScheduleCampaign";
import MediaPreview from "../../Components/MediaPreview";
import DateSelector from "../../Components/DateSelector";
import ShowScreenDetails from "../../Components/ShowScreenDetails";
import ShowScreens from "../../Components/ShowScreens";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
// console.log("ShowScreenDetails", campaign);
export default function MessageLog() {
  const [campaigns, setCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchByType, setSearchByType] = useState("");
  const [limit, setLimit] = useState(10);
  const [fromTime, setFromTime] = useState("");
  const [tillTime, setTillTime] = useState("");
  const [isClick, setIsClick] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCampaign, setTotalCampaign] = useState(0);
  console.log("inside message log componnet==>", campaigns);
  console.log("inside message log componnet==>", campaigns);
  const getCampaign = (from, till) => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      filter_by: searchByType,
      from: fromTime,
      till: tillTime,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/campaigns", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalCampaign(res.data.totalCount);
          setCampaign(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCampaign("", "");
  }, [limit, pageNumber, searchByType, isClick]);

  const changePage = ({ selected }) => setPageNumber(selected);

  function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    // return minutes + " Min";
  }

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">Message Management</h1>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      <DateSelector
                        action={() => setIsClick(!isClick)}
                        from={setFromTime}
                        to={setTillTime}
                      />
                    </h3>
                    <div class="card-tools row">
                      <div className="col-8">
                        <div
                          className="input-group input-group-sm my-auto"
                          style={{ width: 250 }}
                        >
                          <input
                            type="text"
                            name="table_search"
                            className="form-control float-right"
                            placeholder="Search Campaign"
                            value={searchFilter}
                            onChange={(e) => setSearchFilter(e.target.value)}
                          />
                          <div className="input-group-append">
                            <button
                              type="submit"
                              className="btn btn-default"
                              onClick={() => getCampaign("", "")}
                            >
                              <i className="fas fa-search" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>SL No.</th>
                          <th>Campaign</th>
                          <th>Message</th>
                          <th>User</th>
                          <th>Screen(s)</th>
                          <th>Date and Time</th>
                          {/* <th>Campaign Duration</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>Loading Messge Logs ...</td>
                          </tr>
                        )}
                        {!isLoading && totalCampaign === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No Message Log Found</td>
                          </tr>
                        )}

                        {campaigns?.map((campaign, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>
                              <ScreenShow
                                campaign={campaign}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                screenCount={campaign.screens.length}
                                showCampaign={true}
                              />
                            </td>
                            <td>
                              <MediaPreview
                                type={campaign.media?.type}
                                text={campaign.media?.text}
                                images={campaign.media?.image}
                                video={campaign.media?.video}
                              />
                            </td>
                            <td>
                              {campaign.user?.first_name}{" "}
                              {campaign.user?.last_name}
                            </td>
                            <td>
                              {/* <ScreenShow
                                campaign={campaign}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                screenCount={campaign.screens.length}
                              /> */}
                              {/* <ShowScreenDetails
                                // campaign={campaign}
                                screen={campaign.screens[0]}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                // screenCount={campaign.screens.length}
                              /> */}
                              <ShowScreens screens={campaign.screens} />
                            </td>
                            {/* <td>
                                                            {DateTime.fromMillis(campaign.start_time).toFormat("dd LLL yyyy h:mm a")} - {DateTime.fromMillis(campaign.end_time).toFormat("dd LLL yyyy h:mm a")}
                                                        </td> */}
                            {campaign.status === "schedule" ? (
                              <td>
                                {/* {DateTime.fromMillis(campaign.start_time).toFormat("dd LLL yyyy h:mm a")} - {DateTime.fromMillis(campaign.end_time).toFormat("dd LLL yyyy h:mm a")} */}
                                {DateTime.fromMillis(
                                  new Date(campaign.start_time).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")}{" "}
                                {/* -{" "}
                                {DateTime.fromMillis(
                                  new Date(campaign.end_time).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")} */}
                              </td>
                            ) : (
                              <td>
                                {/* {DateTime.fromMillis(
                                  new Date(campaign.start_time).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")} */}
                                {DateTime.fromMillis(
                                  new Date(campaign.created_date).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")}
                              </td>
                            )}
                            {/* <td>{millisToMinutesAndSeconds(campaign.end_time - campaign.start_time)}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalCampaign > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalCampaign / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
